import React from 'react';
import LanguageButton from '../LanguageSwitcher/LanguageButton';
import './style.scss';

const FloatingLanguageSwitcher = () => (
  <div className="floating-language-switcher">
    <LanguageButton />
  </div>
);

export default FloatingLanguageSwitcher;
